import { PersonalLoanRatesActions } from "./types";

export const getAllPersonalLoanRates = (): PersonalLoanRatesActions => ({
  type: "REQUEST_PERSONAL_LOAN_RATES_DATA",
});

export const getAllPersonalLoanRatesSuccess = (
  payload
): PersonalLoanRatesActions => ({
  type: "REQUEST_PERSONAL_LOAN_RATES_DATA_SUCCESS",
  payload,
});

export const getAllPersonalLoanRatesError = (): PersonalLoanRatesActions => ({
  type: "REQUEST_PERSONAL_LOAN_RATES_DATA_FAILED",
});
